import { Modal, Typography } from 'enable-ui';

import { MODAL_KEY } from 'modules/auth/core/modal-key';
import { CancelButton, SubmitButton } from 'modules/dashboard/styles/dashboard';

import { EndRepeatModalContainer, FooterContainer } from '../styles/event';

import { COLOR, COLOR_CONFIG } from 'constants/color';

export const EditRecurringNotUpdatedEventModal = ({
  onCancel,
  onSubmit,
}: {
  onCancel: () => void;
  onSubmit: () => void;
}) => {
  return (
    <EndRepeatModalContainer>
      <Modal
        header={
          <Typography variant="h4" weight={500} color={COLOR.surfaceNeutralBold['neutral-11']}>
            Edit recurring event
          </Typography>
        }
        closeIconStyle={{
          width: 24,
          height: 24,
        }}
        modalKey={MODAL_KEY.EDIT_RECURRING_NOT_UPDATED_EVENT}
        style={{ background: COLOR_CONFIG.white }}
        footer={
          <FooterContainer>
            <CancelButton variant="outlined" onClick={onCancel}>
              Cancel
            </CancelButton>
            <SubmitButton variant="contained">
              <Typography
                variant="body-2"
                color={COLOR_CONFIG.white}
                weight={600}
                onClick={onSubmit}
              >
                Save
              </Typography>
            </SubmitButton>
          </FooterContainer>
        }
      >
        <Typography
          style={{ marginBottom: 6 }}
          variant="body-2"
          color={COLOR.surfaceNeutralBold['neutral-11']}
        >
          Changes will be applied to this and all following events in the series. Invitees will be
          notified about the updates.
        </Typography>
      </Modal>
    </EndRepeatModalContainer>
  );
};
